import { auth } from 'venuescanner-js/services/auth/control'

window.auth = auth
